import { StyleSheet } from 'react-native';
import { textLight } from '_style/Global.style';

export const styles = StyleSheet.create({
  footer: {
    color: textLight,
    letterSpacing: 5,
  },
});
